// @flow
import * as React from 'react';
import CollapsedBlock from 'components/ContentSection/CollapsedBlock';

type Container = {
  children: React.Node,
};

export class ContentSection extends React.Component<*, *> {
  static Header = (props: Container) => <header>{props.children}</header>;
  static Section = (props: Container) => (
    <section className="ma4">{props.children}</section>
  );
  static Divider = () => <hr className="bt b--solid b--light-gray" />;
  static Meta = (props: { label?: string, children: React.Node }) => {
    return null;
  };

  state = {
    metaExpanded: false,
  };

  collapsedContent: ?HTMLDivElement;

  toggleMeta = () => {
    this.setState(prevState => ({ metaExpanded: !prevState.metaExpanded }));
  };

  render() {
    const children = React.Children.map(this.props.children, el => {
      if (el && el.type === ContentSection.Meta) {
        return (
          <CollapsedBlock
            label={el.props.label || 'Meta Info'}
            open={this.state.metaExpanded}
            onClick={this.toggleMeta}
          >
            {el.props.children}
          </CollapsedBlock>
        );
      }

      return el;
    });

    return <section>{children}</section>;
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/ContentSection.js